import { FC } from 'react';

type Props = {
	className?: string;
};

const SearchIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
	
				<path
					d='M13.8496 13.85L16.9996 17'
					stroke='inherit'
					strokeWidth='1.25'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M15.6 9.3C15.6 5.8206 12.7794 3 9.3 3C5.8206 3 3 5.8206 3 9.3C3 12.7794 5.8206 15.6 9.3 15.6C12.7794 15.6 15.6 12.7794 15.6 9.3Z'
					stroke='inherit'
					strokeWidth='1.25'
					strokeLinejoin='round'
				/>
		</svg>
	);
};

export default SearchIcon;
